import React, { useRef } from 'react';
import './AiCursor.css';

export default function AiCursor({ x, y, visible, text, imageUrl }) {
    const cursorRef = useRef(null);

    // Default abstract cursor image if none provided
    const displayImage = imageUrl || 'https://api.dicebear.com/7.x/bottts/svg?seed=Felix&backgroundColor=4f46e5';

    if (!visible) return null;

    return (
        <div className="ai-cursor-container" style={{ pointerEvents: 'none', zIndex: 9999 }}>
            {/* The actual cursor */}
            <div
                ref={cursorRef}
                className={`ai-cursor ${visible ? 'visible' : 'hidden'}`}
                style={{
                    position: 'fixed',
                    left: `${x}px`,
                    top: `${y}px`,
                    transition: 'left 1.2s cubic-bezier(0.25, 1, 0.5, 1), top 1.2s cubic-bezier(0.25, 1, 0.5, 1)',
                    pointerEvents: 'none',
                    display: 'flex',
                    alignItems: 'flex-start' // Ensure the point of the arrow matches the coordinate
                }}
            >
                <div className="cursor-arrow-body">
                    <img
                        src={displayImage}
                        alt="AI Cursor"
                        loading="lazy"
                        style={{
                            width: '32px',
                            height: '32px',
                            borderRadius: '50%',
                            border: '2px solid white',
                            boxShadow: '0 2px 10px rgba(0,0,0,0.2)'
                        }}
                    />
                    {text && (
                        <div className="cursor-label">
                            {text}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}
